import HasBenchmark from "./HasBenchmark";
import {keys} from "../config/nameSpacesKeys";

export default class HasBenchmarkList {
  constructor(name, initialValue = [], namespace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.admsNameSpace = keys.admsIdentifier;
    this.notationNameSpace = keys.notation;
    this.schemaAgencyNameSpace = keys.schemaAgency;
    this.hasBenchmarkList = [];
    this.isEditor = isEditor;
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.hasBenchmarkList;
  }

  setObjList(fhasBenchmarkList) {
    this.hasBenchmarkList = fhasBenchmarkList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.hasBenchmarkList.length) {
      return;
    }
    this.hasBenchmarkList.splice(index, 1);
  }

  addValueObj(obj) {
    const hasBenchmark = new HasBenchmark(this.name, obj, this.namespace, this.isEditor);
    this.hasBenchmarkList.push(hasBenchmark);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        // console.log(value, this.namespace);
        this.addValueObj(value);
      }
    } else {
      if (!obj && this.isEditor) { // if it is undefined - either it is empty coming from editor ,
        // either it is empty coming from landing page. both need different handling
        this.addValueObj(obj);
      }
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.hasBenchmarkList.length; index++) {
      const docItem = this.hasBenchmarkList[index];
      expandedList.push(docItem.getExpandedFormatValue());
    }
    // console.log(expandedList);
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.hasBenchmarkList.length; index++) {
      const docItem = this.hasBenchmarkList[index];
      condition = condition && docItem.isEmpty();
    }
    return condition;
  }
}
